import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=3dd80be1&"
import script from "./Token.vue?vue&type=script&lang=ts&"
export * from "./Token.vue?vue&type=script&lang=ts&"
import style0 from "./Token.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports